import React, { FC, useState } from 'react'
import moment from 'moment'
import { Button } from 'transfix-ui/components/Button'
import { Box } from 'transfix-ui/core'
import { DatePicker } from 'components/forms'

interface IDateRangeFilterMobileProps {
  onChange: (dates: (Date | undefined)[]) => void
  startDate?: string | null
  endDate?: string | null
  onlyFutureDates?: boolean
}

/** Individual date range filters for mobile */
export const DateRangeFilterMobile: FC<IDateRangeFilterMobileProps> = ({
  endDate: endDateProp,
  onChange,
  onlyFutureDates: onlyFutureDatesProp,
  startDate: startDateProp,
}) => {
  const [startAtDate, setStartAtDate] = useState<string>(startDateProp || '')
  const [endAtDate, setEndAtDate] = useState<string>(endDateProp || '')
  const startAtDateHandler = ([selected]: string[]) => {
    setStartAtDate(selected)
  }
  const endAtDateHandler = ([selected]: string[]) => {
    setEndAtDate(selected)
  }
  const submitHandler = () => {
    const startDate = startAtDate ? moment(startAtDate).toDate() : undefined
    const endDate = endAtDate ? moment(endAtDate).toDate() : undefined
    onChange([startDate, endDate])
  }

  return (
    <Box>
      <Box>
        <label className='label' htmlFor='start-at'>
          Start At Date
        </label>
        <DatePicker
          large
          id='start-at'
          placeholder='mm/dd/yyyy'
          onDateChange={startAtDateHandler}
          date={startAtDate || ''}
          minDate={onlyFutureDatesProp ? moment().toDate() : undefined}
        />
      </Box>
      <Box pt={2}>
        <label className='label' htmlFor='start-at'>
          End At Date
        </label>
        <DatePicker
          large
          id='end-at'
          placeholder='mm/dd/yyyy'
          onDateChange={endAtDateHandler}
          date={endAtDate || ''}
          minDate={onlyFutureDatesProp ? moment().toDate() : undefined}
        />
      </Box>
      <Box mt={3}>
        <Button color='primary' size='large' fullWidth onClick={submitHandler}>
          Apply Filter
        </Button>
      </Box>
    </Box>
  )
}
